"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const styles = (theme) => ({
    root: {
        borderRadius: '4px',
        boxShadow: '0 0 10px 0 rgba(16,26,46,0.07)',
    },
    title: {
        color: theme.palette.text.primary,
    },
    cardPadding: {},
    content: {},
});
const StyledCard = (props) => {
    const { children, classes, title, padding } = props;
    return (react_1.default.createElement(core_1.Card, { className: classes.root },
        react_1.default.createElement(core_1.Box, { padding: padding },
            title && (react_1.default.createElement(core_1.CardHeader, { title: title, titleTypographyProps: { variant: 'h2' }, className: classes.title })),
            react_1.default.createElement(core_1.CardContent, { className: classes.content }, children))));
};
StyledCard.defaultProps = {
    padding: 2,
};
StyledCard.propTypes = {
    title: prop_types_1.default.string,
    padding: prop_types_1.default.number,
};
exports.default = (0, styles_1.withStyles)(styles)(StyledCard);
